// API client for Projects (scene snapshots + PDF links)

import { authenticatedJsonRequest } from '../../auth/authenticatedFetch';

async function request(path, options = {}) {
  return authenticatedJsonRequest(path, options);
}

/**
 * Создание проекта. Ответ: { project, quote?, quoteWarning? }.
 */
export async function createProject(payload) {
  return request('/api/projects', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function listProjects() {
  return request('/api/projects');
}

export async function getProject(id) {
  return request(`/api/projects/${id}`);
}

/**
 * Обновление проекта (перезапись снапшота в кабинете).
 */
export async function updateProject(id, payload) {
  return request(`/api/projects/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}

export async function deleteProject(id) {
  return request(`/api/projects/${id}`, {
    method: 'DELETE',
  });
}
